module.exports = __webpack_public_path__ + "static/favicon-9bcde899689c270bbbfa520b969883b9.ico";